unit xweb.FileService;

interface

uses x.FileServiceTypes, xweb.xdata, xdata.Web.Client, js, Web, vcl.tmsfnctypes,
  x.json, x.json.types, classes;

type
  txFileServiceEvent = procedure(s: string; aError: string) of object;

type
  tXFileService = class(tWXDataBase)
  private
    FonFileOK: txFileServiceEvent;
    FonFileError: txFileServiceEvent;

  public
   fPathMap: tStringList;
    [async]
    function GetFiles(adir, amask: string; aRecur: boolean): tbsFileList;  ;  async;
    [async]
    function GetURLDir(aURL, amask: string; aRecur: boolean): tbsFileList; ;  async;
    function UploadURL(aURL: string; atext: string): boolean;
    [async]
    function downloadURL(aURL: string): string; ;  async;
    [async]
    function NewFile(aURL: string; atext: string): boolean;  async;
    [async]
    function DeleteURL(aURL: string): boolean;  ;  async;
    [async]
    function RenameURL(aURL: string; aNewURL: string): boolean; ;  async;
     [async]
    function GetPathMap: TStringlist;async;
  published
    property onFileError: txFileServiceEvent read FonFileError write FonFileError;
    property onFileOK: txFileServiceEvent read fOnFileOK write fonFileOK;

  end;

var
  xdFS: tXFileService;

implementation

{ tXFileService }

function tXFileService.GetPathMap: TStringlist;

var
 s: string;
   response: txdataClientResponse;
begin
  if assigned(fPathMap)=false then fPathMap:=tStringlist.create;
  response := await(Client.RawInvokeasync('IFileService.GetPathMap', []));
    s := String(tJSObject(response.result)['value']);
      fPathMap.text:=s;
      result:=fPathMap;
end;

 function tXFileService.NewFile(aURL: string; atext: string): boolean;
var
  response: txdataClientResponse;
begin
  response := await(Client.RawInvokeAsync('IFileService.UploadUrlText',
    [aURL, atext]));
  result := boolean(tJSObject(response.result)['value']);
end;

function tXFileService.DeleteURL(aURL: string): boolean;
var
  response: txdataClientResponse;
begin
  response := await(Client.RawInvokeAsync('IFileService.DeleteURL', [aURL]));
  result := boolean(tJSObject(response.result)['value']);
end;

function tXFileService.RenameURL(aURL: string; aNewURL: string): boolean;
var
  response: txdataClientResponse;
begin
  response := await(Client.RawInvokeAsync('IFileService.RenameURL',
    [aURL, aNewURL]));
  result := boolean(tJSObject(response.result)['value']);
end;

function tXFileService.downloadURL(aURL: string): string;
var
  response: txdataClientResponse;
begin
console.log('Starting download');
  response :=
    await(Client.RawInvokeAsync('IFileService.downloadURLtext', [aURL]));
  console.log('Finished Download');
  result := string(tJSObject(response.result)['value']);

end;

function tXFileService.GetFiles(adir, amask: string; aRecur: boolean)
  : tbsFileList;
var
  response: txdataClientResponse;
  rv: tJSObject;
  rs, rvs: string;
  rp: tobject;
  alist: tbsFileList;
  afile: tbsFIle;
  afiles: tbsfiles;
  ro: tJSObject;
  s: string;
begin
  CONsole.log('GetFiles', adir);
  response := await(Client.RawInvokeAsync('IFileService.GetFiles',
    [adir, amask, aRecur]));
  rvs := string(tJSObject(response.result)['value']);
  //CONsole.log(rvs, response);
  alist := tbsFileList.create;
  afiles := tbsfiles.create;
  afile := tbsFIle.create;
  ro := response.resultasObject;
  s := TJSJSON.stringify(ro);
  CONsole.log(s);

  alist.json := s;

 // CONsole.log('ALIST', alist);
  result := alist;
end;

function tXFileService.GetURLDir(aURL, amask: string; aRecur: boolean)
  : tbsFileList;
var
  response: txdataClientResponse;
  rv: tJSObject;
  rs, rvs: string;
  rp: tobject;
  afiles: tbsfiles;
  alist: tbsFileList;
  afile: tbsFIle;
  ops: txjOps;
  ro: tJSObject;
  s: string;
begin
  CONsole.log('GetURLDir', aURL);
  response := await(Client.RawInvokeAsync('IFileService.GetURLDir',
    [aURL, amask, aRecur]));
  rvs := string(tJSObject(response.result)['value']);
  CONsole.log(rvs, response);
  alist := tbsFileList.create;
  afiles := tbsfiles.create;
  afile := tbsFIle.create;
  ro := response.resultasObject;
  s := TJSJSON.stringify(ro);
  //CONsole.log(s);
  // alist.JSON:=s;
  ops := txjOps.create;
  ops.mode := xjEx;
  ops.noclasstype:=true;
  ops.ap('files.svChecktime');
  ops.ap('files.svWriteTime');
  ops.ap('files.svAccessTime');
  ops.ap('files.svCreateTime');
    ops.ap('files.$type');
      ops.ap('$type');

  ops.LoadFromJson(alist, s);
  CONsole.log('ALIST', alist.files.count);
  result := alist;
end;

function tXFileService.UploadURL(aURL, atext: string): boolean;
  procedure OnR(response: txdataClientResponse);
  var
    r: boolean;
  begin
    CONsole.log('UploadURL Response');
    r := boolean(tJSObject(response.result)['value']);
    if r = false then
    begin
      if assigned(onFileError) then
        onFileError(aURL, '');
    end
    else
    begin
      if assigned(onFileOK) then
        onFileOK(aURL, '');

    end;
  end;

begin

  Client.RawInvoke('IFileService.UploadURLText', [aURL, atext], @OnR);
end;

end.
